(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
/* eslint-disable padding-line-between-statements */ function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this._initialState = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this._state = initialState;
        this._status = "idle";
        this._score = 0;
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(i) {
                    var _this1 = _this, _loop = function(j) {
                        if (newRow[j] === newRow[j + 1] && newRow[j] !== 0) {
                            newRow[j] += newRow[j + 1];
                            _this1._score += newRow[j];
                            newRow.splice(j + 1, 1);
                            newRow.push(0);
                            tempNumb.forEach(function(el) {
                                if (el.toCol === j) {
                                    el.toCol = j;
                                    el.isMerged = true;
                                    el.isMoved = el.fromCol !== j;
                                } else if (el.toCol === j + 1) {
                                    el.toCol = j + 1;
                                    el.isMerged = true;
                                    el.isMoved = true;
                                }
                                if (el.toCol > j + 1) el.toCol -= 1;
                            });
                        }
                    };
                    var _numbersPos;
                    var tempNumb = [];
                    var newRow = newState[i].filter(function(el, index) {
                        if (el !== 0) tempNumb.push({
                            fromRow: i,
                            fromCol: index
                        });
                        return el !== 0;
                    });
                    tempNumb.forEach(function(el, index) {
                        el.toRow = i;
                        el.toCol = index;
                        el.isMoved = el.toCol !== el.fromCol;
                    });
                    newRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(newRow).concat((0, $227c6742e0ff6f82$export$71511d61b312f219)(new Array(newState[i].length - newRow.length).fill(0)));
                    for(var j = 0; j < newRow.length - 1; j++)_loop(j);
                    (_numbersPos = numbersPos).push.apply(_numbersPos, (0, $227c6742e0ff6f82$export$71511d61b312f219)(tempNumb));
                    newState[i] = newRow;
                };
                if (this._status !== "playing") return [];
                var newState = (0, $227c6742e0ff6f82$export$71511d61b312f219)(this._state);
                var numbersPos = [];
                for(var i = 0; i < newState.length; i++)_loop(i);
                this._state = newState;
                if (numbersPos.some(function(el) {
                    return el.isMoved || el.isMerged;
                })) {
                    this.spawnNumber();
                    this.updateStatus();
                }
                return numbersPos;
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this, _loop = function(i) {
                    var _this1 = _this, _loop = function(j) {
                        if (newRow[j] === newRow[j - 1] && newRow[j] !== 0) {
                            newRow[j] += newRow[j - 1];
                            _this1._score += newRow[j];
                            newRow.splice(j - 1, 1);
                            newRow.unshift(0);
                            tempNumb.forEach(function(el) {
                                if (el.toCol === j) {
                                    el.toCol = j;
                                    el.isMerged = true;
                                } else if (el.toCol === j - 1) {
                                    el.toCol = j - 1;
                                    el.isMerged = true;
                                    el.isMoved = true;
                                }
                                if (el.toCol < j - 1) el.toCol += 1;
                            });
                        }
                    };
                    var _numbersPos;
                    var tempNumb = [];
                    var newRow = newState[i].filter(function(el, index) {
                        if (el !== 0) tempNumb.push({
                            fromRow: i,
                            fromCol: index
                        });
                        return el !== 0;
                    });
                    tempNumb.forEach(function(el, index) {
                        el.toRow = i;
                        el.toCol = newState[i].length - newRow.length + index;
                        el.isMoved = el.toCol !== el.fromCol;
                    });
                    newRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(new Array(newState[i].length - newRow.length).fill(0)).concat((0, $227c6742e0ff6f82$export$71511d61b312f219)(newRow));
                    for(var j = newRow.length - 1; j > 0; j--)_loop(j);
                    (_numbersPos = numbersPos).push.apply(_numbersPos, (0, $227c6742e0ff6f82$export$71511d61b312f219)(tempNumb));
                    newState[i] = newRow;
                };
                if (this._status !== "playing") return [];
                var newState = (0, $227c6742e0ff6f82$export$71511d61b312f219)(this._state);
                var numbersPos = [];
                for(var i = 0; i < newState.length; i++)_loop(i);
                this._state = newState;
                if (numbersPos.some(function(el) {
                    return el.isMoved || el.isMerged;
                })) {
                    this.spawnNumber();
                    this.updateStatus();
                }
                return numbersPos;
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this, _loop = function(i) {
                    var _this1 = _this, _loop = function(j1) {
                        if (newCol[j1] === newCol[j1 + 1] && newCol[j1] !== 0) {
                            newCol[j1] += newCol[j1 + 1];
                            _this1._score += newCol[j1];
                            newCol.splice(j1 + 1, 1);
                            newCol.push(0);
                            tempNumb.forEach(function(el) {
                                if (el.toRow === j1) {
                                    el.toRow = j1;
                                    el.isMerged = true;
                                } else if (el.toRow === j1 + 1) {
                                    el.toRow = j1 + 1;
                                    el.isMerged = true;
                                    el.isMoved = true;
                                }
                                if (el.toRow > j1 + 1) el.toRow -= 1;
                            });
                        }
                    };
                    var _numbersPos;
                    var newCol = [];
                    var tempNumb = [];
                    for(var j = 0; j < newState.length; j++)if (newState[j][i] !== 0) {
                        newCol.push(newState[j][i]);
                        tempNumb.push({
                            fromRow: j,
                            fromCol: i
                        });
                    }
                    tempNumb.forEach(function(el, index) {
                        el.toRow = index;
                        el.toCol = i;
                        el.isMoved = el.toRow !== el.fromRow;
                    });
                    newCol = (0, $227c6742e0ff6f82$export$71511d61b312f219)(newCol).concat((0, $227c6742e0ff6f82$export$71511d61b312f219)(new Array(newState.length - newCol.length).fill(0)));
                    for(var j1 = 0; j1 < newCol.length; j1++)_loop(j1);
                    for(var j2 = 0; j2 < newState.length; j2++)newState[j2][i] = newCol[j2];
                    (_numbersPos = numbersPos).push.apply(_numbersPos, (0, $227c6742e0ff6f82$export$71511d61b312f219)(tempNumb));
                };
                if (this._status !== "playing") return [];
                var newState = (0, $227c6742e0ff6f82$export$71511d61b312f219)(this._state);
                var numbersPos = [];
                for(var i = 0; i < newState[0].length; i++)_loop(i);
                this._state = newState;
                if (numbersPos.some(function(el) {
                    return el.isMoved || el.isMerged;
                })) {
                    this.spawnNumber();
                    this.updateStatus();
                }
                return numbersPos;
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this, _loop = function(i) {
                    var _this1 = _this, _loop = function(j1) {
                        if (newCol[j1] === newCol[j1 - 1] && newCol[j1] !== 0) {
                            newCol[j1] += newCol[j1 - 1];
                            _this1._score += newCol[j1];
                            newCol.splice(j1 - 1, 1);
                            newCol.unshift(0);
                            tempNumb.forEach(function(el) {
                                if (el.toRow === j1) {
                                    el.toRow = j1;
                                    el.isMerged = true;
                                } else if (el.toRow === j1 - 1) {
                                    el.toRow = j1 - 1;
                                    el.isMerged = true;
                                    el.isMoved = true;
                                }
                                if (el.toRow < j1 - 1) el.toRow += 1;
                            });
                        }
                    };
                    var _numbersPos;
                    var newCol = [];
                    var tempNumb = [];
                    for(var j = 0; j < newState.length; j++)if (newState[j][i] !== 0) {
                        newCol.push(newState[j][i]);
                        tempNumb.push({
                            fromRow: j,
                            fromCol: i
                        });
                    }
                    tempNumb.forEach(function(el, index) {
                        el.toRow = newState.length - newCol.length + index;
                        el.toCol = i;
                        el.isMoved = el.toRow !== el.fromRow;
                    });
                    newCol = (0, $227c6742e0ff6f82$export$71511d61b312f219)(new Array(newState.length - newCol.length).fill(0)).concat((0, $227c6742e0ff6f82$export$71511d61b312f219)(newCol));
                    for(var j1 = newCol.length - 1; j1 > 0; j1--)_loop(j1);
                    for(var j2 = 0; j2 < newState.length; j2++)newState[j2][i] = newCol[j2];
                    (_numbersPos = numbersPos).push.apply(_numbersPos, (0, $227c6742e0ff6f82$export$71511d61b312f219)(tempNumb));
                };
                if (this._status !== "playing") return [];
                var newState = (0, $227c6742e0ff6f82$export$71511d61b312f219)(this._state);
                var numbersPos = [];
                for(var i = 0; i < newState[0].length; i++)_loop(i);
                this._state = newState;
                if (numbersPos.some(function(el) {
                    return el.isMoved || el.isMerged;
                })) {
                    this.spawnNumber();
                    this.updateStatus();
                }
                return numbersPos;
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this._score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return structuredClone(this._state);
            }
        },
        {
            key: "updateStatus",
            value: function updateStatus() {
                if (this.isWin()) this._status = "win";
                else if (!this.canMove()) this._status = "lose";
            }
        },
        {
            // Повертає поточний статус
            key: "getStatus",
            value: function getStatus() {
                return this._status;
            }
        },
        {
            key: "start",
            value: function start() {
                if (this._status === "idle") {
                    this._status = "playing";
                    this.spawnNumber();
                    this.spawnNumber();
                    this._score = 0;
                }
            }
        },
        {
            key: "reset",
            value: function reset() {
                this._state = structuredClone(this._initialState);
                this._score = 0;
                this._status = "idle";
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.reset();
            }
        },
        {
            key: "spawnNumber",
            value: function spawnNumber() {
                var freeCell = [];
                if (!this._state.some(function(row) {
                    return row.includes(0);
                })) return false;
                for(var i = 0; i < this._state.length; i++){
                    for(var j = 0; j < this._state[i].length; j++)if (this._state[i][j] === 0) freeCell.push({
                        x: j,
                        y: i
                    });
                }
                var randPos = Math.floor(Math.random() * freeCell.length);
                var newXpos = freeCell[randPos].x;
                var newYpos = freeCell[randPos].y;
                var PROPABILITY_PERCENT = 10;
                var valuePropability = Math.random() * 100;
                var number = valuePropability <= PROPABILITY_PERCENT ? 4 : 2;
                this._state[newYpos][newXpos] = number;
                return true;
            }
        },
        {
            key: "isWin",
            value: function isWin() {
                return this._state.some(function(row) {
                    return row.includes(2048);
                });
            }
        },
        {
            key: "canMove",
            value: function canMove() {
                if (this._state.some(function(row) {
                    return row.includes(0);
                })) return true;
                for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++){
                    var current = this._state[i][j];
                    if (i < 3 && current === this._state[i + 1][j]) return true;
                    if (j < 3 && current === this._state[i][j + 1]) return true;
                }
                return false;
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$table = document.querySelector(".game-field");
var $197cd56b15c33885$var$btnGame = document.querySelector(".button");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$score = document.querySelector(".game-score");
var $197cd56b15c33885$var$isLocked = true;
$197cd56b15c33885$var$btnGame.addEventListener("click", function(e) {
    if ($197cd56b15c33885$var$btnGame.classList.contains("start")) {
        if ($197cd56b15c33885$var$game.getStatus() === "idle") {
            $197cd56b15c33885$var$isLocked = false;
            $197cd56b15c33885$var$start();
            $197cd56b15c33885$var$messageStart.classList.add("hidden");
        }
        $197cd56b15c33885$var$btnGame.blur();
    }
    if ($197cd56b15c33885$var$btnGame.classList.contains("restart")) $197cd56b15c33885$var$restartGame();
});
document.addEventListener("keydown", function(e) {
    if ($197cd56b15c33885$var$isLocked) return;
    var prevState = $197cd56b15c33885$var$game.getState();
    if (e.key === "ArrowLeft") $197cd56b15c33885$var$game.moveLeft();
    if (e.key === "ArrowRight") $197cd56b15c33885$var$game.moveRight();
    if (e.key === "ArrowUp") $197cd56b15c33885$var$game.moveUp();
    if (e.key === "ArrowDown") $197cd56b15c33885$var$game.moveDown();
    $197cd56b15c33885$var$drawState(prevState, $197cd56b15c33885$var$game.getState());
    switch($197cd56b15c33885$var$game.getStatus()){
        case "playing":
            $197cd56b15c33885$var$isLocked = false;
            $197cd56b15c33885$var$btnGame.textContent = "Restart";
            $197cd56b15c33885$var$btnGame.classList.remove("start");
            $197cd56b15c33885$var$btnGame.classList.add("restart");
            break;
        case "win":
            $197cd56b15c33885$var$messageWin.classList.remove("hidden");
            $197cd56b15c33885$var$isLocked = true;
            break;
        case "lose":
            $197cd56b15c33885$var$messageLose.classList.remove("hidden");
            $197cd56b15c33885$var$isLocked = true;
            break;
        case "idle":
            $197cd56b15c33885$var$isLocked = true;
            break;
    }
});
// Start the game
function $197cd56b15c33885$var$start() {
    var prevState = $197cd56b15c33885$var$game.getState();
    $197cd56b15c33885$var$game.start();
    var state = $197cd56b15c33885$var$game.getState();
    $197cd56b15c33885$var$drawState(prevState, state);
}
function $197cd56b15c33885$var$drawState(prevState, newState) {
    $197cd56b15c33885$var$score.textContent = $197cd56b15c33885$var$game.getScore();
    for(var i = 0; i < newState.length; i++)for(var j = 0; j < newState[i].length; j++){
        var cell = $197cd56b15c33885$var$getCell(i, j);
        cell.className = "field-cell";
        cell.textContent = "";
        if (newState[i][j] !== 0) {
            if (prevState[i][j] !== newState[i][j]) cell.classList.add("field-cell--animation");
            cell.classList.add("field-cell--" + newState[i][j]);
            cell.textContent = newState[i][j].toString();
        }
    }
}
function $197cd56b15c33885$var$getCell(numRow, numCol) {
    var rows = $197cd56b15c33885$var$table.querySelectorAll(".field-row");
    return rows[numRow].querySelectorAll(".field-cell")[numCol];
}
function $197cd56b15c33885$var$restartGame() {
    var prevState = $197cd56b15c33885$var$game.getState();
    $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$drawState(prevState, $197cd56b15c33885$var$game.getState());
    $197cd56b15c33885$var$btnGame.textContent = "Start";
    $197cd56b15c33885$var$btnGame.classList.remove("restart");
    $197cd56b15c33885$var$btnGame.classList.add("start");
    $197cd56b15c33885$var$messageStart.classList.remove("hidden");
    $197cd56b15c33885$var$messageLose.classList.add("hidden");
    $197cd56b15c33885$var$messageWin.classList.add("hidden");
    $197cd56b15c33885$var$btnGame.blur();
}

})();
//# sourceMappingURL=index.fd8df00b.js.map
